export const CUSTOM_BRAND_NAMES = [
    "RT-HEPE-2024-04",
    "RT-WADC-2024-04",
    "RT-CONY-2024-04",
    "RT-STVE-2024-04",
    "RT-BOMA-2024-04",
    "GA-CLFL-2024-04",
    "GA-NATE-2024-04",
    "GA-MYSC-2024-04",
    "GS-NACA-2024-04",
    "GS-SEAZ-2024-04",
    "GS-FOFL-2024-04",
    "CD-CHOO-2024-04",
];
const customBrandDisclaimer = "<div><h2>Award Details & Traveler Responsibility</h2><ul><li>Travel awards are valid for two travelers, double occupancy. Family awards are valid for four travelers, one room unless otherwise indicated.</li><li>Travel is to be completed by June 3, 2025.</li><li>Travel is excluded December 16 - January 6.</li><li>A 45-day advance reservation is required. Awards are based on availability at the time of request; however, it is always recommended to book early for your preferred travel dates.</li><li>All travel awards include sales tax. The following items are not included unless otherwise noted: Country departure tax, resort fees, premium seating on flights, checked baggage, fuel, parking, and insurance.</li><li>Prepaid debit cards are non-refundable and expire one year after issuance. The card must be activated prior to use and cannot be used for cash.</li><li>Hotels and activities are subject to change based on availability.</li><li>Please contact the travel department at 612.720.3308, Mon-Fri 8am-4:30pm CT with questions and to make reservations.</li><li>During the travel event, you may have the opportunity to participate in various optional activities such as water sports, contests, excursions, and side trips. I agree that neither Keurig Dr. Pepper nor Live Well Travel shall be held liable for any injury, damage, loss, expense, delay, or inconvenience arising out of my participation in the travel program, except to the extent such injury, damage, loss, expense, delay, or inconvenience is caused by the respective sole negligence or willful misconduct of Keurig Dr. Pepper or Live Well Travel.</li><li>Department of Homeland Security now requires all passengers to provide Secure Flight Passenger Data which includes your full legal name (as listed on your government-issued identification i.e., driver's license or passport), date of birth including year, and gender at the time of booking. When booking International Travel, a passport is required along with your passport name, passport number, and expiration date. We are unable to book your reservation if this information cannot be provided.</li></ul><h2>Program Information</h2><p><strong>Accuracy of quotes:</strong> Costs and inclusions are accurate at the time of the quote and may change without notice.</p><p><strong>Air Fares:</strong> Costs are estimated at the time of proposal based on U.S. National Averages from the 48 contiguous states. Any airfare originating outside the 48 states will be billed accordingly upon actual costs at the time of booking. Country departure taxes, checked baggage, and premium seat fees, if applicable, are not included.</p><p><strong>Hotels:</strong> The minimum age for hotel check-in is 21 years old with a major credit card in their own name. Rates do not include resort fees or gratuities unless otherwise indicated.</p><p><strong>Car Rentals:</strong> Rates do not include fuel, insurance, or parking, and renters must be at least 25 years old with a major credit card in their own name.</p><p><strong>Prepaid Debit Cards:</strong> Prepaid debit cards are non-refundable and non-transferable. Cards cannot be replaced if lost or stolen and must be activated upon receipt. They can be used everywhere that debit cards are accepted. Other restrictions may apply, including minimum purchase amounts and maximum number of payment forms. Cards cannot be used for cash withdrawals.</p><p><strong>Cancellation/change penalties:</strong> Travel reservations, once booked, are immediately paid in full upon confirmation. For this reason, bookings are non-refundable and non-transferable. If reservations need to be changed, we will do all possible to assist. A $75.00 per person fee will apply, in addition to any charges imposed by airlines, hotels, car rentals, or other suppliers. In the event of a no-show, reservations are completely non-refundable. BIW offers travel insurance at the time of booking at the traveler’s expense. We highly recommend purchasing travel insurance for protection against any last-minute changes that may impact the ability to travel. Travel Insurance is optional but highly recommended.</p><p><strong>EU General Data Protection Regulation (GDPR):</strong> Live Well Travel is GDPR compliant. Personal information needed to finalize travel awards will follow compliance requirements.</p></div>";
export const TRAVEL_REWARD_CATALOG = {
    date: "2024-04",
    brands: [
        {
            amount: 2500,
            utid: "RT-HEPE-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "RT-HEPE-2024-04",
                brandName: "Hershey, Pennsylvania (Road Trip)",
                description: "<div><h2>Three days / two nights / Inclusion for two travelers / $2,500 (Land only)</h2><ul><li>Two nights’ accommodations at The Hotel Hershey with seasonal admission to Hershey Gardens and Hershey Story’s Museum</li><li>One select 50-minute spa service per person at The Chocolate Spa</li><li>$200 prepaid card to cover mileage, dining, parking, and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/RT-HEPE-2024-04.png",
                },
                items: [
                    {
                        faceValue: 2500,
                        rewardName: "Hershey, Pennsylvania (Road Trip)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "RT-HEPE-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 3,
            },
        },
        {
            amount: 2500,
            utid: "RT-WADC-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "RT-WADC-2024-04",
                brandName: "Washington, DC (Road Trip)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Three days / two nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $2,500 (Land only)</p><ul><li>Two nights' accommodations at JW Marriott Washington DC or similar</li><li>Breakfast at the hotel each day</li><li>A choice of one activity per person:</li><ul><li>Washington DC City Day or Night Tour</li><li>Dinner one night at McCormick and Schmick's</li></ul><li>$350 prepaid card to cover mileage, dining, parking, and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/RT-WADC-2024-04.png",
                },
                items: [
                    {
                        faceValue: 2500,
                        rewardName: "Washington, DC (Road Trip)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "RT-WADC-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 3,
            },
        },
        {
            amount: 2500,
            utid: "RT-CONY-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "RT-CONY-2024-04",
                brandName: "Cooperstown, New York (Road Trip)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Three days / two nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $2,500 (Land only)</p><ul><li>Two nights' accommodations at The Otesaga Resort Hotel Cooperstown</li><li>Breakfast at the hotel each day</li><li>Two tickets to the National Baseball Hall of Fame & Museum</li><li>Dinner one night at the hotel</li><li>$200 prepaid card to cover mileage, dining, parking, and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/RT-CONY-2024-04.png",
                },
                items: [
                    {
                        faceValue: 2500,
                        rewardName: "Cooperstown, New York (Road Trip)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "RT-CONY-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 3,
            },
        },
        {
            amount: 2500,
            utid: "RT-STVE-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "RT-STVE-2024-04",
                brandName: "Stowe, Vermont (Road Trip)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Three days / two nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $2,500 (Land only)</p><ul><li>Two nights' accommodations at Topnotch Resort</li><li>Breakfast at the hotel each day</li><li>Seasonal activity:</li><ul><li>Winter: Two days' lift tickets per person</li><li>Fall/Summer: Full-day fat bike or electric bike rental per person</li></ul><li>$200 prepaid card to cover mileage, dining, parking, and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/RT-STVE-2024-04.png",
                },
                items: [
                    {
                        faceValue: 2500,
                        rewardName: "Stowe, Vermont (Road Trip)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "RT-STVE-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 3,
            },
        },
        {
            amount: 2500,
            utid: "RT-BOMA-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "RT-BOMA-2024-04",
                brandName: "Boston, Massachusetts (Road Trip)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Three days / two nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $2,500 (Land only)</p><ul><li>Two nights' accommodations at Boston Marriott Copley Place or similar</li><li>Breakfast at the hotel each day</li><li>Boston History and Highlights Walking Tour – see the best sights in Boston:<ul><li>Beacon Hill</li><li>The Freedom Trail</li><li>Faneuil Hall</li><li>And more!</li></ul></li><li>Dinner one night at choice of The Chart House or Del Frisco's</li><li>$350 prepaid card to cover mileage, dining, parking, and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/RT-BOMA-2024-04.png",
                },
                items: [
                    {
                        faceValue: 2500,
                        rewardName: "Boston, Massachusetts (Road Trip)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "RT-BOMA-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 3,
            },
        },
        {
            amount: 3500,
            utid: "GA-NATE-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GA-NATE-2024-04",
                brandName: "Nashville, Tennessee (Get Away)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Three days / two nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $3,500</p><ul><li>Round-trip air for two from home city to Nashville (48 states)</li><li>Two nights' accommodations at the Westin Nashville or similar</li><li>Round-trip transportation from the Nashville airport to the Westin</li><li>Breakfast at the hotel each day</li><li>A choice of one activity per person:<ul><li>RCA Studio B with one-day admission to the Country Music Hall of Fame</li><li>Ryman Auditorium Tour</li></ul></li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GA-NATE-2024-04.png",
                },
                items: [
                    {
                        faceValue: 3500,
                        rewardName: "Nashville, Tennessee (Get Away)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GA-NATE-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 2,
            },
        },
        {
            amount: 3500,
            utid: "GA-MYSC-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GA-MYSC-2024-04",
                brandName: "Myrtle Beach, South Carolina (Get Away)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Four days / three nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $3,500</p><ul><li>Round-trip air for two from home city to South Carolina (48 states)</li><li>Three nights' accommodations at the Hilton Myrtle Beach Resort or similar</li><li>Full Size Car Rental for four days</li><li>Breakfast at the hotel each day</li><li>Two-hour guided stand-up paddleboard tour</li><li>Resort Fees included</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GA-MYSC-2024-04.png",
                },
                items: [
                    {
                        faceValue: 3500,
                        rewardName: "Myrtle Beach, South Carolina (Get Away)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GA-MYSC-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 2,
            },
        },
        {
            amount: 4500,
            utid: "GA-CLFL-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GA-CLFL-2024-04",
                brandName: "Clearwater Beach, Florida (Get Away)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Four days / three nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $4,500</p><ul><li>Round-trip air for two from home city to Tampa, Florida (48 states)</li><li>Three nights' accommodations at the Sheraton Sand Key Resort or similar</li><li>Round-trip transportation from the Tampa airport to the Sheraton Sand Key</li><li>Breakfast at the hotel each day</li><li>Sunset Cruise from Clearwater</li><li>Dinner at the Hotel for one night</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GA-CLFL-2024-04.png",
                },
                items: [
                    {
                        faceValue: 4500,
                        rewardName: "Clearwater Beach, Florida (Get Away)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GA-CLFL-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 2,
            },
        },
        {
            amount: 5000,
            utid: "GS-NACA-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GS-NACA-2024-04",
                brandName: "Napa, California (Going Somewhere)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Four days / three nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $5,000</p><ul><li>Round-trip air for two from home city to San Francisco, California (48 states)</li><li>Three nights' accommodations at the River Terrace Inn Napa or similar</li><li>Full Size Rental Car for four days</li><li>Breakfast at the hotel each day</li><li>Resort Fees</li><li>Choice of one activity:<ul><li>Winemaker for a Day Experience at a Napa Winery</li><li>Small Group Wine Tour with lunch</li></ul></li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GS-NACA-2024-04.png",
                },
                items: [
                    {
                        faceValue: 5000,
                        rewardName: "Napa, California (Going Somewhere)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GS-NACA-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 1,
            },
        },
        {
            amount: 5000,
            utid: "GS-SEAZ-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GS-SEAZ-2024-04",
                brandName: "Sedona, Arizona (Going Somewhere)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Four days / three nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $5,000</p><ul><li>Round-trip air for two from home city to Phoenix, Arizona (48 states)</li><li>Three nights' accommodations at the Hilton Sedona Resort At Bell Rock or similar</li><li>Full Size Rental Car for four days</li><li>Breakfast at the hotel each day</li><li>Resort Fees</li><li>Choice of one activity:<ul><li>Sedona Canyon Off-Road Tour</li><li>Red Rock Guided Hike</li></ul></li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GS-SEAZ-2024-04.png",
                },
                items: [
                    {
                        faceValue: 5000,
                        rewardName: "Sedona, Arizona (Going Somewhere)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GS-SEAZ-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 1,
            },
        },
        {
            amount: 5000,
            utid: "GS-FOFL-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "GS-FOFL-2024-04",
                brandName: "Fort Lauderdale, Florida (Going Somewhere)",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Four days / three nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $5,000</p><ul><li>Round-trip air for two from home city to Fort Lauderdale, Florida (48 states)</li><li>Three nights' accommodations at the Diplomat Beach Resort or similar</li><li>Round-trip transportation from the Fort Lauderdale Airport</li><li>Breakfast at the hotel each day</li><li>Fort Lauderdale Water Taxi – Daily Unlimited with 15 stops</li><li>Dinner at the Hotel for one night</li><li>Resort Fees</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/GS-FOFL-2024-04.png",
                },
                items: [
                    {
                        faceValue: 5000,
                        rewardName: "Fort Lauderdale, Florida (Going Somewhere)",
                        rewardType: "Travel",
                        status: "active",
                        utid: "GS-FOFL-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 1,
            },
        },
        {
            amount: 5000,
            utid: "CD-CHOO-2024-04",
            type: "FIXED_VALUE",
            metadata: {
                brandKey: "CD-CHOO-2024-04",
                brandName: "Choose Your Destination",
                description: "<div><h2>Travel Package Details</h2><p><strong>Duration:</strong> Five days / four nights</p><p><strong>Inclusion:</strong> For two travelers</p><p><strong>Cost:</strong> $5,000</p><ul><li>Round-trip air for two from home city to destination city (48 states)</li><li>Four nights' accommodations at a four-star hotel within your destination choice</li><li>Full Size Rental Car for five days</li><li>Breakfast at the hotel each day</li><li>Dinner for two at the hotel destination for two nights</li><li>$250 prepaid card to cover mileage, dining, parking and incidentals</li></ul></div>",
                disclaimer: customBrandDisclaimer,
                imageUrls: {
                    firebaseImage: "/images/CD-CHOO-2024-04.png",
                },
                items: [
                    {
                        faceValue: 5000,
                        rewardName: "Choose Your Destination",
                        rewardType: "Travel",
                        status: "active",
                        utid: "CD-CHOO-2024-04",
                        valueType: "FIXED_VALUE",
                    },
                ],
                status: "active",
                priority: 0,
            },
        },
    ],
};
//# sourceMappingURL=travelPackages.js.map